module.exports = __webpack_public_path__ + "static/media/Icons-6.6a240708.svg";